import axios from 'axios'
import router from '@/router.js'

import store from '../store' ;//引入状态管理 store

// 配置默认的host,假如你的API host是：http://api.htmlx.club
// axios.defaults.baseURL = 'https://api.longpuji.com/gateway/'   
// axios.defaults.baseURL = 'http://192.168.9.84:8060/gateway-dev/'   
axios.defaults.baseURL = 'https://api.jiapuji.vip/gateway/'  


axios.defaults.withCredentials = false            //非打包环境
if( process.env.NODE_ENV != "development" ){      //打包后
    axios.defaults.withCredentials = true
}
// console.log('axios.js => axios.defaults.withCredentials',axios.defaults.withCredentials)


// 添加请求拦截器
axios.interceptors.request.use(function (config) {
　　// 在发送请求之前做些什么
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Authorization'] = 'Bearer ' +    store.state.token;
　　return config
}, function (error) {
　　// 对请求错误做些什么
    return Promise.reject(error)
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
   
　　// 对响应数据做点什么
　　return response
}, function (error) {
　　// 对响应错误做点什么
    
    //router.push({path:'/'});
　　 return Promise.reject(error)
});


